var _defs, _path, _path2, _path3, _polyline, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoadBPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 362.38,
    height: 475.83,
    viewBox: "0 0 362.38 475.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-3 {\r\n        fill: none;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-1 {\r\n        stroke: #ed1c24;\r\n      }\r\n\r\n      .cls-1, .cls-3 {\r\n        stroke-width: 3px;\r\n      }\r\n\r\n      .cls-2, .cls-3 {\r\n        stroke: #414042;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-width: 5px;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #020202;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-336.09,243.28",
    transform: "translate(-6.72 -5.38)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.91,481.21v-258a210.31,210.31,0,0,0-10.62-44.34,191.28,191.28,0,0,0-19.56-39.63Q61.22,73.1,8.68,6.94",
    transform: "translate(-6.72 -5.38)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.92,481.21v-258a209.69,209.69,0,0,1,10.62-44.34,191.28,191.28,0,0,1,19.56-39.63q52.51-66.18,105-132.34",
    transform: "translate(-6.72 -5.38)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "102.54 1.55 180.21 112.4 253.97 1.55"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M225.63,205.44c-3.23-9.6-7-19.8-11.38-30.43",
    transform: "translate(-6.72 -5.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M206.33,156.87c-4.87-10.55-9.81-20.22-14.64-29",
    transform: "translate(-6.72 -5.38)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.27,459.59v15.92a.72.72,0,0,1-.63.79.7.7,0,0,1-.78-.62.49.49,0,0,1,0-.17V459.59a.71.71,0,0,1,.62-.79.72.72,0,0,1,.79.62Z",
    transform: "translate(-6.72 -5.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M188.06,459l6.89,6.89a.71.71,0,0,1-1,1l-6.39-6.39-6.34,6.38a.72.72,0,0,1-1,0,.71.71,0,0,1,0-1l6.89-6.89A.72.72,0,0,1,188.06,459Z",
    transform: "translate(-6.72 -5.38)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M226,129l-8,13.79a.71.71,0,0,1-.93.38.73.73,0,0,1-.38-.94l.09-.14,8-13.79a.71.71,0,1,1,1.3.56A.64.64,0,0,1,226,129Z",
    transform: "translate(-6.72 -5.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M226.17,128.35l2.52,9.41a.7.7,0,0,1-.5.86.71.71,0,0,1-.87-.5L225,129.39l-8.68,2.36a.72.72,0,0,1-.86-.5.73.73,0,0,1,.49-.86l9.42-2.52A.71.71,0,0,1,226.17,128.35Z",
    transform: "translate(-6.72 -5.38)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M140.23,117.73l8,13.78a.72.72,0,0,1-.14,1,.71.71,0,0,1-1-.15.42.42,0,0,1-.09-.14l-8-13.79a.71.71,0,0,1,1.14-.85A.71.71,0,0,1,140.23,117.73Z",
    transform: "translate(-6.72 -5.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139.73,117.28l9.41,2.52a.7.7,0,0,1-.36,1.36l-8.73-2.33-2.3,8.69a.73.73,0,0,1-.87.5.71.71,0,0,1-.49-.86l2.52-9.41A.71.71,0,0,1,139.73,117.28Z",
    transform: "translate(-6.72 -5.38)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadBPhoto);
export default __webpack_public_path__ + "static/media/road-B-photo.035ce3cf361761be1dd52abe6ced8775.svg";
export { ForwardRef as ReactComponent };